import {
  drawerWidth,
  drawerSmallWidth,
  transition,
  defaultFont,
  mainColor,
  pinkColor,
  primaryColor,
  primaryBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
  blackColor,
  violetColor,
  hexToRgb
} from "assets/jss/material-dashboard-react.js";

const sidebarStyle = theme => ({
  drawerPaper: {
    border: "none",
    position: "fixed",
    top: "0",
    bottom: "0",
    left: "0",
    zIndex: "1",
    width: drawerWidth,
    height: "100vh",
    paddingTop: "56px",
    [theme.breakpoints.down("sm")]: {
      width: drawerSmallWidth
    },
    [theme.breakpoints.down("xs")]: {
      width: drawerSmallWidth,
      position: "fixed",
      display: "block",
      top: "0",
      height: "100vh",
      left: "0",
      right: "auto",
      zIndex: "1028",
      visibility: "visible",
      overflowY: "visible",
      borderTop: "none",
      textAlign: "left",
      paddingRight: "0px",
      paddingLeft: "0",
      ...transition
    }
  },
  drawerPaperMobile: {
    border: "none",
    position: "fixed",
    top: "0",
    bottom: "0",
    left: "0",
    zIndex: "1",
    width: '70%',
    height: "auto",
    paddingTop: "56px",
    [theme.breakpoints.down("sm")]: {
      width: '70%'
    },
    [theme.breakpoints.down("xs")]: {
      width: '70%',
      position: "fixed",
      display: "block",
      top: "0",
      height: "100vh",
      left: "0",
      right: "auto",
      zIndex: "1028",
      visibility: "visible",
      overflowY: "scroll",
      borderTop: "none",
      textAlign: "left",
      paddingRight: "0px",
      paddingLeft: "0",
      ...transition
    }
  },
  sidebarWrapper: {
    [theme.breakpoints.down("sm")]: {
      width: drawerSmallWidth,
      paddingRight: "0px"
    },
    position: "relative",
    overflow: "auto",
    width: drawerWidth,
    zIndex: "4",
    overflowScrolling: "touch",
    flex: "1 0 0px",
    height: "initial"
  },
  sidebarWrapperMobile: {
    [theme.breakpoints.down("sm")]: {
      width: '100%',
      paddingRight: "0px"
    },
    position: "relative",
    overflow: "auto",
    width: '100%',
    zIndex: "4",
    overflowScrolling: "touch",
    flex: "1 0 0px",
    height: "initial"
  },
  drawerPaperRTL: {
    [theme.breakpoints.up("md")]: {
      left: "auto !important",
      right: "0 !important"
    },
    [theme.breakpoints.down("sm")]: {
      left: "0  !important",
      right: "auto !important"
    }
  },
  logo: {
    position: "relative",
    padding: "15px 15px",
    zIndex: "4",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "0",

      height: "1px",
      right: "15px",
      width: "calc(100% - 30px)",
      backgroundColor: "rgba(" + hexToRgb(grayColor[6]) + ", 0.3)"
    }
  },
  logoLink: {
    ...defaultFont,
    textTransform: "uppercase",
    padding: "5px 0",
    display: "block",
    fontSize: "18px",
    textAlign: "left",
    fontWeight: "400",
    lineHeight: "30px",
    textDecoration: "none",
    backgroundColor: "transparent",
    "&,&:hover": {
      color: whiteColor
    }
  },
  logoLinkRTL: {
    textAlign: "right"
  },
  logoImage: {
    width: "30px",
    display: "inline-block",
    maxHeight: "30px",
    marginLeft: "10px",
    marginRight: "15px"
  },
  img: {
    width: "35px",
    top: "22px",
    position: "absolute",
    verticalAlign: "middle",
    border: "0"
  },
  background: {
    position: "absolute",
    zIndex: "1",
    height: "100%",
    width: "100%",
    display: "block",
    top: "0",
    left: "0",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    "&:after": {
      position: "absolute",
      zIndex: "3",
      width: "100%",
      height: "100%",
      content: '""',
      display: "block",
      background: blackColor,
      opacity: ".8"
    }
  },
  list: {
    marginBottom: "0px",
    paddingLeft: "0",
    // paddingRight: "1rem",
    paddingTop: "0.5rem",
    listStyle: "none",
    position: "unset",
    borderBottom: "1px solid #00000080",
    '&:last-child': {
      borderBottom: "none"
    }
  },
  item: {
    position: "relative",
    display: "block",
    textDecoration: "none",
    padding: "0.15rem 0",
    "&:hover,&:focus,&:visited,&": {
      color: blackColor
    }
  },
  itemLink: {
    width: "auto",
    minHeight: "32px",
    transition: "all 300ms linear",
    margin: "0 0.5rem 0 1rem",
    borderRadius: "3px",
    position: "relative",
    padding: "0",
    backgroundColor: "transparent",
    wordBreak: "break-word",
    display: "flex",
    alignItems: "center",
    ...defaultFont
  },
  itemLinkBottom: {
    width: "auto",
    height: "40px",
    transition: "all 300ms linear",
    margin: "0 15px 0",
    borderRadius: "3px",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    padding: "5px 0px",
    backgroundColor: "transparent",
    color: violetColor[2],
    ...defaultFont
  },
  itemIcon: {
    width: "22px",
    minWidth: "22px",
    height: "22px",
    fontSize: "22px",
    lineHeight: "30px",
    float: "left",
    marginRight: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    maxWidth: "none",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.8)",
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down("sm")]: {
      marginRight: 0
    },
  },
  itemSmallIcon: {
    width: "18px",
    height: "18px",
    fontSize: "24px",
    lineHeight: "30px",
    float: "left",
    marginRight: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    maxWidth: "none",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.8)",
    [theme.breakpoints.down("sm")]: {
      marginRight: 0
    },
  },
  itemIconBottom: {
    width: "24px",
    height: "30px",
    fontSize: "24px",
    lineHeight: "30px",
    float: "right",
    textAlign: "center",
    verticalAlign: "middle",
    color: violetColor[2]
  },
  itemIconRTL: {
    marginRight: "3px",
    marginLeft: "15px",
    float: "right"
  },
  itemText: {
    ...defaultFont,
    margin: "0",
    lineHeight: "30px",
    fontSize: "14px",
    color: blackColor
  },
  itemTextMobile: {
    ...defaultFont,
    margin: "0",
    marginLeft: '15px',
    lineHeight: "30px",
    fontSize: "14px",
    color: blackColor
  },
  itemTextRTL: {
    textAlign: "right"
  },
  whiteFont: {
    color: whiteColor
  },
  violetFont: {
    color: "#0D9488"
  },
  purple: {
    backgroundColor: primaryColor[0],
    ...primaryBoxShadow,
    "&:hover,&:focus": {
      backgroundColor: primaryColor[0],
      ...primaryBoxShadow
    }
  },
  blue: {
    backgroundColor: infoColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(infoColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(infoColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: infoColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(infoColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(infoColor[0]) +
        ",.2)"
    }
  },
  green: {
    backgroundColor: successColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(successColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(successColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: successColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(successColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(successColor[0]) +
        ",.2)"
    }
  },
  orange: {
    backgroundColor: warningColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(warningColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(warningColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: warningColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(warningColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(warningColor[0]) +
        ",.2)"
    }
  },
  red: {
    backgroundColor: dangerColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: dangerColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(dangerColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(dangerColor[0]) +
        ",.2)"
    }
  },
  violet: {
    padding: "0 0 0 1rem",
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#F0FDFA",
    color: "#0D9488",
    borderLeft: "4px solid #0D9488",
    borderRadius: 0,
    "& $itemIcon": {
      color: "#0D9488"
    },
    "& $itemText": {
      color: "#0D9488"
    },
    "&:hover,&:focus": {
      backgroundColor: "#F0FDFA",
      color: "#0D9488",
    }
  },
  activePro: {
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      width: "100%",
      bottom: "13px"
    }
  },
  wrapUserInfo: {
    marginTop: 0,
    display: "flex",
    alignItems: "center"
  },
  wrapUserInfoMobile: {
    marginTop: 0,
    display: "flex",
    alignItems: "center"
  },
  userInfo: {
    color: "#000",
    display: "flex",
    flexFlow: "column",
    fontSize: "0.8rem"
  },
  userInfoMobile: {
    color: "#000",
    display: "flex",
    flexFlow: "column",
    fontSize: "0.8rem",
    marginLeft: 15,
  }
});

export default sidebarStyle;
